import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ChecklistCategoriesComponent } from './checklist-categories.component';
import { ColorCircleModule } from 'ngx-color/circle';

const routes: Routes = [
  { path: '', component: ChecklistCategoriesComponent, data: { title: 'Checklist Categories' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes), ColorCircleModule],
  exports: [RouterModule],
})
export class ChecklistCategoriesRoutingModule {}

@NgModule({
  imports: [
    ChecklistCategoriesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ColorCircleModule,
  ],
  declarations: [ChecklistCategoriesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [ChecklistCategoriesComponent],
})
export class ChecklistCategoriesModule {}
